import React from "react";
import Layout from "../components/layout/Layout";
import ProposalForm from "../components/proposals/ProposalForm";

const ProposalFormPage = () => {
  return (
    <Layout title="Proposal Management">
      <ProposalForm />
    </Layout>
  );
};

export default ProposalFormPage;
